import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.css';

class Tab extends PureComponent {
  ref = createRef();

  handleMouseUp = event => {
    this.blur();
    if (this.props.onMouseUp) {
      this.props.onMouseUp(event);
    }
  };

  handleMouseLeave = event => {
    this.blur();
    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(event);
    }
  };

  blur() {
    if (this.ref.current && this.ref.current.blur) {
      this.ref.current.blur();
    }
  }

  render() {
    const { children, active, ...rest } = this.props;
    const hasAction = !!this.props.onClick;
    const classNames = cx(styles.tab, {
      [styles.active]: active,
      [styles.hasAction]: !!this.props.onClick,
    });

    const ElementToUse = hasAction ? 'button' : 'div';

    return (
      <ElementToUse
        ref={this.ref}
        onMouseUp={this.handleMouseUp}
        onMouseLeave={this.handleMouseLeave}
        type={hasAction ? 'button' : undefined}
        className={classNames}
        {...rest}
      >
        {children}
      </ElementToUse>
    );
  }
}

export default Tab;
